import { TestedPartyMapping } from "../models/tested-party-mapping/TestedPartyMapping";

export enum CompanyCodeType {
    PROVIDER = 'PROVIDER',
    TESTED_PARTY = 'TESTED_PARTY',
}

/**
 * Filters CLI numbers from mappings by tested party company code.
 * Returns distinct CLI numbers matching the given tested party code.
 */
export function getClisByTestedPartyCode(mappings: TestedPartyMapping[], testedPartyCode: string): string[] {
    const clis = new Set<string>();
    for (const mapping of mappings) {
        if (mapping.testedPartyCompanyCode === testedPartyCode && mapping.cliNumber) {
            clis.add(mapping.cliNumber);
        }
    }
    return Array.from(clis);
}

/**
 * Returns the full mapping records for a tested party company code, de-duplicated by CLI number
 * (first occurrence wins). Unlike {@link getClisByTestedPartyCode} this preserves each CLI's enriched
 * functionalSegmentCategory, so the report CLI dropdown can be filtered by functional segment in
 * Tested Party mode.
 */
export function getMappingsByTestedPartyCode(
    mappings: TestedPartyMapping[],
    testedPartyCode: string
): TestedPartyMapping[] {
    const seen = new Set<string>();
    const result: TestedPartyMapping[] = [];
    for (const mapping of mappings) {
        if (mapping.testedPartyCompanyCode === testedPartyCode && mapping.cliNumber && !seen.has(mapping.cliNumber)) {
            seen.add(mapping.cliNumber);
            result.push(mapping);
        }
    }
    return result;
}

/**
 * Looks up the firstPartyCompanyCode for a given CLI from tested party mappings.
 * Returns undefined if no matching CLI is found.
 */
export function getProviderCodeForCli(mappings: TestedPartyMapping[], cliNumber: string): string | undefined {
    const mapping = mappings.find(m => m.cliNumber === cliNumber);
    return mapping?.firstPartyCompanyCode;
}
